import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {AppService, StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {IUser} from "../../../interfaces";
import {Lib} from "../../../../libs/Lib";

@Component({
    selector: 'app-overview-card',
    templateUrl: './overview-card.component.html',
    styleUrls: ['./overview-card.component.scss'],
    standalone: false
})
export class OverviewCardComponent extends Compbaser implements OnInit {
    user: IUser;
    isResellerStatusActive = false;
    isAccessDenied = false;
    isAccountUpgradable = true;

    constructor(private router: Router,
                private appService: AppService,
                private cd: ChangeDetectorRef,
                public override dialog: MatDialog,
                private storeSelector: StoreSelectorsService) {
        super();
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.isResellerStatusActive = Lib.IsResellerStatusActive(user);
                this.isAccessDenied = Lib.IsAccessBlocked(user);
                this.isAccountUpgradable = Lib.IsAccountUpgradable(user);
                this.cd.markForCheck();
            })
        );
    }

    @Input() type: number;
    @Input() val1: any;
    @Input() val2: any;
    @Input() val3: any;
    @Input() val4: any;
    @Input() valA: any;
    @Input() valB: any;
    @Input() title = '';

    ngOnInit() {
        this.cod(
            this.storeSelector.getUser().subscribe((i_user: IUser) => {
                this.user = i_user;
            })
        );
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
        this.router.navigateByUrl('/home');
    }
}

